var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('input',{ref:"chbox",staticClass:"uk-checkbox",attrs:{"type":"checkbox"},on:{"click":_vm.checkTheBox}})])}
var staticRenderFns = []

export { render, staticRenderFns }